import { _ } from "../../core/polyglot/polyglot.js";
import { configureDialog } from "../../core/widgets/dialogs/dialogs.js";
import { notBlank } from "../../core/widgets/forms/validators.js";
import AccountingCoordinator from "../shared/documentInfrastructure/AccountingCoordinator.js";

/**
 * Model holding all the parts of a forecasting archive document, its
 * widgets and its state. It handles communication between all of
 * these by registering to events and dispatching them via message
 * sends.
 */
export default class ForecastTemplateArchiveDocumentCoordinator extends AccountingCoordinator {
	_setupContentCallbacks() {
		return {
			getForecastUrl: this._getForecastEditorUrl.bind(this),
			onForecastTemplateCreationRequest:
				this._makeForecastTemplate.bind(this),
			onForecastTemplateCopyRequest:
				this._copyForecastTemplate.bind(this),
		};
	}

	_getForecastEditorUrl({ forecastTemplate }) {
		return this._router.linkTo("forecast-editor/#forecastTemplateId", {
			forecastTemplateId: forecastTemplate.getId(),
		});
	}

	async _makeForecastTemplate() {
		if (!(await this._documentState.hasDefaultForecastConfiguration())) {
			this._router.redirectTo("forecast-onboarding");
			return;
		}

		this._showForecastCreationDialog();
	}

	_showForecastCreationDialog() {
		const model = { description: "" };

		configureDialog({
			title: _("Create a forecast template"),
			okLabel: _("Create"),
			formSpec: {
				model,
				saveAction: () => this._onSaveForecastTemplate({ model }),
			},
			formBuilder: (form) => {
				form.input({
					name: "name",
					attribute: "name",
					label: _("Template name"),
					validator: notBlank(),
				});

				form.wysiwyg({
					accessor: () => model.description,
					attribute: "description",
					label: _("Description"),
					name: "description",
					toolbarAlwaysVisible: true,
				});
			},
		}).show();
	}

	async _onSaveForecastTemplate({ model, description }) {
		const forecastTemplate = await this._documentState.makeForecastTemplate(
			{
				model,
				description,
			},
		);

		return this._router.redirectTo("forecast-editor/#forecastTemplateId", {
			forecastTemplateId: forecastTemplate.getId(),
		});
	}

	async _copyForecastTemplate({ forecastTemplate, model }) {
		const newForecastTemplate =
			await this._documentState.copyForecastTemplate({
				forecastTemplate,
				model,
			});

		return this._redirectTo("forecast-editor/#forecastTemplateId", {
			forecastTemplateId: newForecastTemplate.getId(),
		});
	}
}
